import { createSelector } from 'reselect';
import { AppState } from '../..';

export const getSavedSpacesById = (state: AppState) => state.spaces.spaces;
export const getSpacesAccessById = (state: AppState) => state.spaces.spaceAccess;

export const savedSpacesList = createSelector(getSavedSpacesById, spaces => Object.values(spaces));
export const spacesAccessList = createSelector(getSpacesAccessById, spaceAccess =>
  Object.values(spaceAccess),
);

export const getAllSpacesReady = (state: AppState) =>
  !state.spaces.allSpaces.loading &&
  state.spaces.allSpaces.lastRequested > 0 &&
  !state.spaces.allSpaces.error;

export const getDefaultSpace = createSelector(savedSpacesList, spaces =>
  spaces.find(s => s.isDefault),
);
